<dx-list *ngIf="roleLocations.length > 0"
         class="dx-list-boxed mb-2 h-auto"
         [dataSource]="roleLocations"
         [hoverStateEnabled]="false"
         [activeStateEnabled]="false"
         [focusStateEnabled]="false"
         [allowItemDeleting]="true"
         (onItemDeleted)="deleteRoleLocation($event)">
    <dxo-item-dragging [allowReordering]="false"></dxo-item-dragging>
    <div *dxTemplate="let roleLocation of 'item'">
        <span>{{roleLocation.team?.name}}</span>
    </div>
</dx-list>

<adapt-select-team *ngIf="this.configurableTeams.length > 0"
                   [required]="false"
                   [filter]="teamFilter"
                   [(team)]="selectedTeam"
                   (teamChange)="onTeamSelected($event)"></adapt-select-team>
